import { render } from "./DiscountDecisionDashboard.vue?vue&type=template&id=a5cc58aa&scoped=true"
import script from "./DiscountDecisionDashboard.vue?vue&type=script&lang=js"
export * from "./DiscountDecisionDashboard.vue?vue&type=script&lang=js"

import "./DiscountDecisionDashboard.vue?vue&type=style&index=0&id=a5cc58aa&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a5cc58aa"]])

export default __exports__